import React from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { AlertType } from '../../../shared/enum/EnumRepository';
import { paperTextureMobile } from '../../../shared/component/paperTexture';
import { slideInFromBottom } from '../../../shared/component/Animation';
import { MediumIcon } from '../../../shared/component/IconBody';
import logo from '../../../asset/gnb/logo_fit.png';
import { paddingBottomWithSafeArea } from '../../../shared/constants/safeArea';
import { ContentMobile } from './AlertCompMobile';

const SystemAlertCompMobile: React.FC = () => {
  const { queue } = useStandardAlertStore();
  if (queue.length === 0) return null;
  const currentStandardAlert = queue[0];

  return (
    <AlertContentMobile>
      <AlertHeaderMobile>
        <MediumIcon src={logo} alt='logo icon' />
      </AlertHeaderMobile>
      <TitleMobile>{currentStandardAlert.type === AlertType.EMERGENCY ? 'Temporarily Paused' : 'On Hold'}</TitleMobile>
      <ContentMobile>{currentStandardAlert.content}</ContentMobile>
    </AlertContentMobile>
  );
};

const AlertHeaderMobile = styled.div`
  margin: 6px 0px 12px 0px;
  user-select: none;
`;

const AlertContentMobile = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: fit-content;
  min-height: 24vw;

  padding: 20px 20px ${paddingBottomWithSafeArea('20px')} 20px;
  outline: none;

  ${paperTextureMobile}
  background-color: ${({ theme }) => theme.colors.color_White};
  ${slideInFromBottom}
`;

const TitleMobile = styled.h2`
  color: ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_02_1};
`;

export default SystemAlertCompMobile;
